module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_2.4447b736.png";